import { useState } from 'react';
import { dashboard } from '../lib/api';
import { useResource } from '../hooks/useResource';
import { formatDateTime, formatDuration, statusTone } from '../lib/format';
import { Alert, Badge, Card, Empty, Spinner } from '../components/ui';

export function Logs() {
  const [page, setPage] = useState(1);
  const logs = useResource(() => dashboard.requests(page), [page]);

  const pagination = logs.data?.pagination;

  return (
    <>
      <div className="page-header">
        <h1>Request logs</h1>
        <p>Every API call made with your keys, newest first.</p>
      </div>

      {logs.error && <Alert>{logs.error}</Alert>}

      <Card
        title={pagination ? `${pagination.total} requests` : 'Requests'}
        actions={
          <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
            <button
              className="btn btn-sm"
              onClick={() => setPage((current) => current - 1)}
              disabled={page <= 1}
            >
              Previous
            </button>
            <span className="muted">
              {page} / {pagination?.total_pages ?? 1}
            </span>
            <button
              className="btn btn-sm"
              onClick={() => setPage((current) => current + 1)}
              disabled={!pagination?.has_more}
            >
              Next
            </button>
          </div>
        }
      >
        {logs.loading ? (
          <Spinner />
        ) : !logs.data?.items.length ? (
          <Empty>No requests recorded yet.</Empty>
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Method</th>
                  <th>Path</th>
                  <th>Status</th>
                  <th>Duration</th>
                  <th>Error</th>
                  <th>Request ID</th>
                </tr>
              </thead>
              <tbody>
                {logs.data.items.map((entry) => (
                  <tr key={entry.id}>
                    <td className="muted">{formatDateTime(entry.createdAt)}</td>
                    <td className="mono">{entry.method}</td>
                    <td className="mono">{entry.path}</td>
                    <td>
                      <Badge tone={statusTone(entry.statusCode)}>{entry.statusCode}</Badge>
                    </td>
                    <td className="mono">{formatDuration(entry.durationMs)}</td>
                    <td className="mono muted">{entry.errorCode ?? '—'}</td>
                    <td className="mono muted">{entry.requestId}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </>
  );
}
